import { useEffect, useLayoutEffect, useState } from 'react'
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom'
import { Menu, X } from 'lucide-react'
import { useSession } from '../lib/session'
import { reducedMotion } from '../features/public/motion'

// Páginas do site no visual escuro (home.css); termos, privacidade e exclusão de dados seguem claras.
const DARK_ROUTES = ['/', '/precos', '/agencias', '/como-funciona']

export default function PublicLayout() {
  const { me } = useSession()
  const [open, setOpen] = useState(false)
  const { pathname } = useLocation()
  useEffect(() => setOpen(false), [pathname])
  // Os elementos "revela ao rolar" só ficam escondidos com html.motion-ok: sem JS/observador o conteúdo continua visível.
  useLayoutEffect(() => {
    if (reducedMotion()) return
    document.documentElement.classList.add('motion-ok')
    return () => document.documentElement.classList.remove('motion-ok')
  }, [])
  useEffect(() => {
    if (!open) return
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(false) }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [open])

  // No celular só "Entrar" vai para o menu; o botão principal continua no cabeçalho.
  const cta = me ? (
    <Link to="/app" className="btn primary">Abrir o painel</Link>
  ) : (
    <>
      <Link to="/login" className="btn ghost public-login">Entrar</Link>
      <Link to="/cadastro" className="btn primary">Testar grátis</Link>
    </>
  )
  return (
    <div className={`public-shell ${DARK_ROUTES.includes(pathname) ? 'public-dark' : ''}`} style={{ background: 'var(--surface)', minHeight: '100vh' }}>
      <div className="public-nav-bar">
      <header className="public-nav">
        <Link to="/" className="logo" style={{ padding: 0 }}>
          <img src="/logo.png" alt="" className="logo-img" />
          Seu Impulso
        </Link>
        <nav className="links" aria-label="Site">
          <NavLink to="/como-funciona">Como funciona</NavLink>
          <NavLink to="/precos">Preços</NavLink>
          <NavLink to="/agencias">Para agências</NavLink>
        </nav>
        <div className="row actions">{cta}</div>
        <button type="button" className="icon-btn public-menu-btn" aria-label={open ? 'Fechar menu' : 'Abrir menu'} aria-expanded={open} aria-controls="public-menu" onClick={() => setOpen(!open)}>
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </header>
      {open && (
        <nav id="public-menu" className="public-menu" aria-label="Menu do site">
          <NavLink to="/como-funciona">Como funciona</NavLink>
          <NavLink to="/precos">Preços</NavLink>
          <NavLink to="/agencias">Para agências</NavLink>
          {!me && <NavLink to="/login">Entrar</NavLink>}
        </nav>
      )}
      </div>
      <Outlet />
      <footer className="public-footer">
        <div className="inner">
          <span className="copy">© {new Date().getFullYear()} Seu Impulso</span>
          <nav className="links" aria-label="Rodapé">
            <Link to="/como-funciona">Como funciona</Link>
            <Link to="/precos">Preços</Link>
            <Link to="/agencias">Para agências</Link>
            <Link to="/termos">Termos de uso</Link>
            <Link to="/privacidade">Privacidade</Link>
            <Link to="/exclusao-de-dados">Exclusão de dados</Link>
          </nav>
          <span className="note">O dinheiro dos anúncios é pago direto às plataformas de anúncio.</span>
        </div>
      </footer>
    </div>
  )
}
